import { Pipe, PipeTransform } from '@angular/core';
import { removeDiacritics } from '../utils/remove-diacritics';

@Pipe({ name: 'highlightFilterSearchTerm' })
export class HighlightFilterSearchTermPipe implements PipeTransform {
  transform(value: string, searchTerm: string, type: 'text' | 'image' = 'text'): string {
    if (!searchTerm) {
      return type === 'image' ? null : value;
    }

    if (type === 'image') {
      const normalizedValue = removeDiacritics(value)?.toLowerCase();
      const normalizedSearch = removeDiacritics(searchTerm)?.toLowerCase();
      return normalizedValue?.includes(normalizedSearch) ? 'ag-image--highlighted' : null;
    }

    // Normalize the value and search term for comparison
    const normalizedValue = removeDiacritics(value);
    const normalizedSearch = removeDiacritics(searchTerm);

    if (!normalizedValue || !normalizedSearch) {
      return value;
    }

    // Create a regular expression to search ignoring diacritics
    const searchRegex = new RegExp(normalizedSearch.split('').join('(\\s?(\\(|\\)|\\-)\\s?)?'), 'gi');

    // Find matching positions in the normalized string
    let result = '';
    let lastIndex = 0;
    let match;

    while ((match = searchRegex.exec(normalizedValue)) !== null) {
      const matchStart = match.index;
      const matchEnd = match.index + match[0].length;

      // Add text before the match (from the original string)
      result += value.substring(lastIndex, matchStart);
      // Add the match with highlighting (from the original string)
      result += `<span class="dx-datagrid-search-text">${value.substring(matchStart, matchEnd)}</span>`;
      lastIndex = matchEnd;
    }

    // Add the remaining text
    result += value.substring(lastIndex);

    return result || value;
  }
}
